
function addMousemove(){
  document.addEventListener("mousemove", function(event){
    var changeX = event.clientX;
    var changeY = event.clientY;
    var element = document.querySelector('.bird-outline');

    var eyebrowLeft = document.getElementById("eyebrowLeft");
    var eyebrowRight = document.getElementById("eyebrowRight");

    var pupilLeft = document.getElementById("pupilLeft");
    var eyeballLeft = document.getElementById("eyeballLeft");

    var pupilRight = document.getElementById("pupilRight");
    var eyeballRight = document.getElementById("eyeballRight");


    /* Eyes */
    eyeAreaLeft = eyeballLeft.getBoundingClientRect();
    pupilLeftArea = pupilLeft.getBoundingClientRect();
    R_left = eyeAreaLeft.width / 2;
    r_left = pupilLeftArea.width / 2;
    centerX_left = eyeAreaLeft.left;
    centerY_left = eyeAreaLeft.top;

    var x_left = event.clientX - centerX_left,
    y_left = event.clientY - centerY_left,
    theta_left = Math.atan2(y_left, x_left),
    angle_left = theta_left * 180 / Math.PI + 360;
    
    /* 
    // In case a different calculation for right eye is needed
    
    eyeAreaRight = eyeballRight.getBoundingClientRect();
    pupilRightArea = pupilRight.getBoundingClientRect();
    R_right = eyeAreaRight.width / 2;
    r_right = pupilRightArea.width / 2;
    centerX_right = eyeAreaRight.left;
    centerY_right = eyeAreaRight.top;

    var x_right = event.clientX - centerX_right,
    y_right = event.clientY - centerY_right,
    theta_right = Math.atan2(y_right, x_right),
    angle_right = theta_right * 180 / Math.PI + 360;

    */

    if (pupilLeft && pupilRight) {
      pupilLeft.style.transform = `translateX(${R_left - r_left  / 2 + "px"}) rotate(${angle_left + "deg"})`;
      pupilLeft.style.transformOrigin = `${r_left + (24 - r_left) + "px"} center`;

      pupilRight.style.transform = `translateX(${R_left - r_left  / 2 + "px"}) rotate(${angle_left + "deg"})`;
      pupilRight.style.transformOrigin =  `${r_left + (24 - r_left) + "px"} center`;
    }


    /* Eyebrow */
    var elemBounding = element.getBoundingClientRect();   
    var elementLeftEdge = elemBounding.left;
    var elementTopEdge = elemBounding.top;
    var elementRightEdge = elemBounding.right;
    var elementBottomEdge = elemBounding.bottom;

    var topEdgeDist = Math.abs(elementTopEdge - changeY);
    var bottomEdgeDist = Math.abs(elementBottomEdge - changeY);
    var leftEdgeDist = Math.abs(elementLeftEdge - changeX);
    var rightEdgeDist = Math.abs(elementRightEdge - changeX);

    var min = Math.min(topEdgeDist,bottomEdgeDist,leftEdgeDist,rightEdgeDist);

    if (min == topEdgeDist) {
        getMove = 'top';
        eyebrowLeft.style.transform  = 'translateY(10px)';
        eyebrowRight.style.transform  = 'translateY(10px)';
        eyebrowLeft.setAttribute('d', 'M183.53 225.674C198.651 169.882 275.148 162.461 309.961 197.104C266.322 197.195 228.557 192.441 183.53 225.674Z')
        eyebrowRight.setAttribute('d', 'M353.703 185.867C330.917 143.297 373.152 94.9432 414.164 96.0464C387.698 121.113 362.023 139.862 353.703 185.867Z')

    } else if (min == leftEdgeDist){
        getMove = 'left';
        eyebrowLeft.style.transform  = 'translateY(10px)';
        eyebrowRight.style.transform  = 'translateY(10px)';
        eyebrowLeft.setAttribute('d', 'M180.167 253.33C177.534 195.585 248.114 165.165 291.842 187.527C250.314 200.936 212.9 207.938 180.167 253.33Z')
        eyebrowRight.setAttribute('d', 'M384.558 144.631C417.705 109.52 476.956 134.241 488.916 173.486C456.75 156.336 430.827 137.931 384.558 144.631Z')

    } else if (min == bottomEdgeDist){
        getMove = 'bottom'
        eyebrowLeft.style.transform  = 'translateY(30px)';
        eyebrowRight.style.transform  = 'translateY(30px)';
        eyebrowLeft.setAttribute('d', 'M183.53 225.674C198.651 169.882 275.148 162.461 309.961 197.104C266.322 197.195 228.557 192.441 183.53 225.674Z')
        eyebrowRight.setAttribute('d', 'M353.703 185.867C330.917 143.297 373.152 94.9432 414.164 96.0464C387.698 121.113 362.023 139.862 353.703 185.867Z')
    }
    else if (min == rightEdgeDist){
        getMove = 'right'
        eyebrowLeft.style.transform  = 'translateY(10px)';
        eyebrowRight.style.transform  = 'translateY(10px)';
        eyebrowLeft.setAttribute('d', 'M197.657 247.839C190.478 190.481 258.439 154.59 303.794 173.433C263.453 190.075 226.708 200.006 197.657 247.839Z')
    }
  })
}
  
if (document.attachEvent ? document.readyState === "complete" : document.readyState !== "loading"){
  addMousemove();
} else {
  document.addEventListener('DOMContentLoaded', addMousemove);
}

